import Request from "./Request";

const FlightService = {

    async getFlightJobs() {
        return await Request.get('/api/flight-jobs')
    },

    async createFlightJob(data) {
        return await Request.post('/api/flight-jobs', data)
    },

    async updateFlightJob(flight_job_id) {
        return await Request.put(`/api/flight-jobs/${flight_job_id}`, data)
    },

    async deleteFlightJob(flight_job_id) {
        return await Request._delete(`/api/flight-jobs/${flight_job_id}`)
    },

    async activateFlightJob(flight_job_id) {
        return await Request.post(`/api/flight-jobs/${flight_job_id}/activate`)
    },

    async runFlightJob(flight_job_id, data) {
        return await Request.post(`/api/flight-jobs/${flight_job_id}/run`, data)
    },

    async executeFlightJob(flight_job_log_id) {
        const key = 'scHzcX1L4ZFjj5exMg57dB1aq1HtF0';
        return await Request.post(`/api/flight-jobs/${flight_job_log_id}/execute?key=${key}`);
    },

    async executeDailyLightSpeedJob(flight_job_log_id) {
        const key = 'scHzcX1L4ZFjj5exMg57dB1aq1HtF0';
        return await Request.post(`/api/flight-jobs/execute/lightspeed/${flight_job_log_id}?key=${key}`);
    },
    async uploadDailyLightspeedJob() {
        const key = 'scHzcX1L4ZFjj5exMg57dB1aq1HtF0';
        return await Request.post(`/api/flight-jobs/execute/lightspeed?key=${key}`);
    },

    async deactivateFlightJob(flight_job_id) {
        return await Request.post(`/api/flight-jobs/${flight_job_id}/deactivate`)
    },

    async getFlightJobLogs() {
        return await Request.get('/api/flight-job-logs')
    },

    async broadcastJob() {
        const key = 'scHzcX1L4ZFjj5exMg57dB1aq1HtF0';
        return await Request.post(`/api/flight-jobs/broadcast?key=${key}`)
    }
}

export default FlightService